import { currency } from '@/utilities/helpers';

const OPTION_REGEX = /([a-zA-Z]{1,6})(\d?)(\d{2})(\d{2})(\d{2})([c|p]{1})(\d{5})(\d{3})$/i;

export default class Ticker {
  symbol;
  underlying;
  optionRoot;
  expirationDate;
  strike;
  type;

  constructor(symbol, underlying = null) {
    this.symbol = symbol.toUpperCase();
    this.underlying = underlying;

    this.optionRoot = null;
    this.expirationDate = null;
    this.strike = null;
    this.type = null;

    const match = OPTION_REGEX.exec(this.symbol);
    if (match) {
      this.optionRoot = match[1];

      this.expirationDate = new Date(
        2000 + parseInt(match[3] || '0', 10),
        parseInt(match[4] || '0', 10) - 1, // Months are 0-based in JS
        parseInt(match[5] || '0', 10)
      );

      this.strike = parseFloat(`${match[7] || '0'}.${match[8] || '0'}`);
      this.type = match[6].toUpperCase() === 'C' ? 'Call' : 'Put';
    }
  }

  get isEquity() {
    return !OPTION_REGEX.test(this.symbol);
  }

  get isOption() {
    return OPTION_REGEX.test(this.symbol);
  }

  toString() {
    return this.symbol;
  }

  get description() {
    if (!this.isOption) return this.symbol;

    const date = this.expirationDate
      ? this.expirationDate.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
      : 'Invalid Date';

    return `${date} ${this.formattedStrike} ${this.type}`;
  }

  get isCall() {
    return this.type === 'Call';
  }

  get isPut() {
    return this.type === 'Put';
  }

  get isUnique() {
    return this.underlying.toLowerCase() !== this.optionRoot.toLowerCase();
  }

  get expirationDateString() {
    if (!this.expirationDate) return null;
    return this.expirationDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }

  get formattedStrike() {
    return currency(this.strike);
  }

  // return date in format like YYYY-MM-DD
  get formattedShortDate() {
    return this.expirationDate.toISOString().split('T')[0];
  }

  get typeDescription() {
    const unique = this.isUnique ? `(${this.optionRoot})` : '';
    return this.isCall ? `Call ${unique}` : `Put ${unique}`;
  }
}
